import { type FC } from "react";
import { AlertCircle } from "lucide-react";

import { cn } from "@/shared/lib/utils";

interface FieldErrorProps {
  message: string | null | undefined;
  className?: string;
}

export const FieldError: FC<FieldErrorProps> = ({ message, className }) => {
  if (!message) return null;
  return (
    <p data-field-error className={cn("flex items-center gap-1.5 text-sm text-destructive", className)}>
      <AlertCircle className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      {message}
    </p>
  );
};
